@if (isMobile()) {
  @if (mode() === MediaActionsMode.RECOMMENDATIONS) {
    <cheelee-feed-nav [isMuted]="isMuted()" (toggleMuteClicked)="toggleMute()" />
  } @else {
    <cheelee-header
        [isFixed]="true"
    >
      <div class="header__container">
        <div class="header__go-back">
          <button
              class="header__go-back-btn"
              cheeleeGoBack
              cheeleeRipple
              isCenteredRipple
          >
            <cheelee-icon
                class="header__go-back-icon"
                iconId="arrow-left-icon"
            />
          </button>
        </div>
        <cheelee-top-button
            class="feed-nav__right-bottom"
            [icon]="!isMuted() ? 'sprite.svg#icon-not-muted' : 'sprite.svg#icon-muted'"
            (clicked)="toggleMute()"
            [eventName]="analyticsEvents.VolumeTap"
        />
      </div>
    </cheelee-header>
  }
}

@if (isDesktop()) {
  <div class="swiper-controls">
    <div class="swiper-controls-item" [class.swiper-controls-item--hidded]="!canPrev()" (click)="onPrevSlide()">
      <svg class="swiper-controls-item__icon">
        <use xlink:href="assets/icons/ui-kit-icons.sprite.svg#chevron-up-icon"></use>
      </svg>
    </div>

    <div class="swiper-controls-item" (click)="onNextSlide()">
      <svg class="swiper-controls-item__icon swiper-controls-item__icon--reversed">
        <use xlink:href="assets/icons/ui-kit-icons.sprite.svg#chevron-up-icon"></use>
      </svg>
    </div>
  </div>
}

<div #feedElementRef class="feed" (scroll)="onScroll($event)">
  @for (media of feed(); track i; let i = $index) {
    <cheelee-media-view [index]="i" [feedItem]="media"/>
  }
</div>
